export default "__VITE_ASSET__df36cff3__"